import { endOfMonth, isSaturday, isSunday, nextSaturday, previousSunday } from 'date-fns';
import { localDate } from './date-fns-local';

/** Used by month view to get visible dates (includes visible dates on adjacent months) */
export function getVisibleDates(year, month) {
  const firstOfMonth = localDate(new Date());
  firstOfMonth.setFullYear(year, month, 1);
  firstOfMonth.setHours(0, 0, 0, 0);
  const lastOfMonth = endOfMonth(firstOfMonth);
  const firstSunday = isSunday(firstOfMonth)
    ? firstOfMonth
    : previousSunday(firstOfMonth);
  const lastSaturday = isSaturday(lastOfMonth)
    ? lastOfMonth
    : nextSaturday(lastOfMonth);
  return { firstOfMonth, firstSunday, lastSaturday };
}
